import { useSelector } from "react-redux";

import type { CrmColumnItem } from "app/pages/sales-intelligence/sub-modules/management/types";

import CrmEnrichmentJobFiltersWizardStep from "../../../components/wizard/CrmEnrichmentJobFiltersWizardStep";
import useFiltersActions from "../../../hooks/useFiltersActions";
import { selectSelectedJobObject, selectWizardFilters } from "../../../store/selectors";

type Props = {
    columns: readonly CrmColumnItem[];
    crmFieldOptions: readonly string[];
};

const CrmEnrichmentJobFiltersWizardStepContainer = ({ columns, crmFieldOptions }: Props) => {
    const wizardFilters = useSelector(selectWizardFilters);
    const selectedJobObject = useSelector(selectSelectedJobObject);

    const filtersActions = useFiltersActions(columns);

    return (
        <CrmEnrichmentJobFiltersWizardStep
            {...wizardFilters}
            {...filtersActions}
            crmFieldOptions={crmFieldOptions}
            selectedJobObject={selectedJobObject}
        />
    );
};

export default CrmEnrichmentJobFiltersWizardStepContainer;
